import { render } from "./BackerCenterUpdateFeedCard.vue?vue&type=template&id=b249b8b6"
import script from "./BackerCenterUpdateFeedCard.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__